import React, { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from '@/shared/components/Loading';

const Layout = lazy(() => import('./Layout'));

/**
 * LayoutWrapper - Conditionally renders Layout based on route.
 * Layout (Sidebar/TopHeader/SmartSearch/SetupWizard) is lazy-loaded so the
 * public landing page does not pay for that JS on first paint.
 */
const LayoutWrapper = ({ children, user, onLogout }) => {
  const location = useLocation();

  const publicRoutes = ['/', '/login', '/signup', '/ForgetPassword', '/privacy', '/delete-account', '/support-session'];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  if (isPublicRoute) {
    return children;
  }

  return (
    <Suspense fallback={<Loading fullPage size="lg" color="primary" />}>
      <Layout user={user} onLogout={onLogout}>
        {children}
      </Layout>
    </Suspense>
  );
};

export default LayoutWrapper;
